import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";

import { BlogLayoutComponent } from "./blog.layout";
import { BlogComponent } from "./blog.component";
import { SingleArticleComponent } from "./single-article/single-article.component";

export const routes: Routes = [
    {
        path: "",
        component: BlogLayoutComponent,

        children: [
            {
                path: "",
                component: BlogComponent,
            },
            {
                path: ":id",
                component: SingleArticleComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class BlogRoutingModule {}
